module.exports = __webpack_public_path__ + "static/img/sm_2.586272f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_2.png
// module id = /0UB
// module chunks = 0